<template>
    <div>
        <label style="font-weight: bold; font-size: 14px">{{$t('register.birthDay')}}</label>
        <div class="notranslate select-birth-day-wrapper clearfix">
            <el-form-item :label="$t('register.year')" class="year-of-birth">
                <el-select @change="selectYear" v-model="year" style="width: 100%" type="text"
                           :placeholder="$t('register.year')">
                    <el-option disabled value="">{{$t('register.year')}}</el-option>
                    <el-option v-for="y in years" :value="y" :label="y">{{y}}</el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="$t('register.month')" class="month-of-birth">
                <el-select @change="calculateDaysOfMonth" v-model="month" style="width: 100%" type="text"
                           :placeholder="$t('register.month')">
                    <el-option disabled value="">{{$t('register.month')}}</el-option>
                    <el-option v-for="m in months" :value="m" :label="m">{{m}}</el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="$t('register.day')" class="day-of-birth">
                <el-select @change="setDate" v-model="dayOfMonth" style="width: 100%" type="text"
                           :placeholder="$t('register.day')">
                    <el-option disabled value="">{{$t('register.day')}}</el-option>
                    <el-option v-for="d in daysOfMonth" :value="d" :label="d">{{d}}</el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="birth-day-calendar">
                <el-date-picker id="birth_day" ref="date"
                                v-model="date"
                                type="date"
                                @change="setInfoForSelectItem"
                                value-format="yyyy-MM-dd"
                                :placeholder="$t('register.birthDayPlaceholder')">
                </el-date-picker>
            </el-form-item>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SelectDate",
        data() {
            return {
                years: [],
                months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                daysOfMonth: [],
                year: null,
                month: null,
                dayOfMonth: null,
                date: null
            }
        },

        created() {
            //set data for select date form
            let currentDate = new Date();
            let currentYear = currentDate.getFullYear();
            for (let i = currentYear; i >= currentYear - 100; i--) {
                this.years.push(i)
            }
        },

        methods: {
            setInfoForSelectItem() {
                if (this.date != null && this.date.trim() !== "" && new Date(this.date).getTime()) {
                    let birthDay = new Date(this.date);
                    this.year = birthDay.getFullYear();
                    this.month = birthDay.getMonth() + 1;

                    this.daysOfMonth = [];
                    if (this.year != null && this.year !== "" && this.month != null && this.month !== "") {
                        let daysOfMonth = new Date(this.year, this.month, 0).getDate();
                        for (let i = 1; i <= daysOfMonth; i++) {
                            this.daysOfMonth.push(i)
                        }
                    }

                    this.dayOfMonth = birthDay.getDate();

                    console.log(this.year)
                    console.log(this.month)
                    console.log(this.dayOfMonth)
                }

                this.triggerToValidateData();
            },

            setDate() {
                if (this.year != null && this.year !== "" &&
                    this.month != null && this.month !== "" &&
                    this.dayOfMonth != null && this.dayOfMonth !== "") {

                    this.date = new Date(this.year, (this.month - 1), this.dayOfMonth, 0, 0, 0, 0);
                }
                this.triggerToValidateData();
            },

            selectYear() {
                this.month = "";
                this.dayOfMonth = "";
                this.date = null;
                this.triggerToValidateData();
            },

            calculateDaysOfMonth() {
                if (this.year != null && this.year !== "" && this.month != null && this.month !== "") {
                    this.daysOfMonth = [];
                    let daysOfMonth = new Date(this.year, this.month, 0).getDate();
                    for (let i = 1; i <= daysOfMonth; i++) {
                        this.daysOfMonth.push(i)
                    }

                    this.dayOfMonth = "";
                    this.date = null;
                }
            },

            getSelectedDate() {
                return this.date;
            },

            triggerToValidateData() {
                this.$emit('triggerToValidateData', this.date);
            },

            setSelectedDate(date) {
                if (date !== null && date !== undefined && date !== "") {
                    let selectedDate = new Date(date);
                    this.date = selectedDate;
                    this.year = selectedDate.getFullYear();
                    this.month = selectedDate.getMonth() + 1;
                    this.daysOfMonth = [];
                    if (this.year != null && this.year !== "" && this.month != null && this.month !== "") {
                        let daysOfMonth = new Date(this.year, this.month, 0).getDate();
                        for (let i = 1; i <= daysOfMonth; i++) {
                            this.daysOfMonth.push(i)
                        }
                    }

                    this.dayOfMonth = selectedDate.getDate();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    #register_base_info_title {
        font-weight: bold;
        font-size: 30px
    }

    .select-birth-day-wrapper {
        margin-left: 20px;
        overflow: hidden;

        .year-of-birth, .month-of-birth, .day-of-birth {
            box-sizing: border-box;
            float: left;
            font-weight: bold;
            padding-right: 10px;
            width: calc((100% - 50px) / 3)
        }

        .birth-day-calendar {
            box-sizing: border-box;
            float: right;
            font-weight: bold;
            width: 50px;
        }
    }

    @media screen and (max-width: 1024px) {
        .select-birth-day-wrapper {
            margin-left: 10px !important;;
        }
    }

    @media screen and (max-width: 500px) {
        .select-birth-day-wrapper {
            margin-left: 5px !important;;
        }

        .year-of-birth {
            padding-right: 5px !important;;
            width: calc((100% - 50px) * .4) !important;
        }

        .month-of-birth {
            padding-right: 5px !important;;
            width: calc((100% - 50px) * .3) !important;
        }

        .day-of-birth {
            padding-right: 5px !important;;
            width: calc((100% - 50px) * .3) !important;
        }
    }

    .birth-day-calendar {
        /deep/ .el-icon-date {
            font-size: 40px;
            margin-top: 13px;
            color: black;
        }

        .el-input__inner {
            display: none !important;
        }

        /deep/ input {
            display: none !important;
        }

        /deep/ .el-input__suffix {
            display: none;
        }

        .el-input__inner {
            display: none !important;
        }
    }

    .el-date-editor el-input el-input--prefix el-input--suffix el-date-editor--date {
        input {
            display: none;
        }
    }

</style>